module.exports={"Star Rating":"星評価","# star(s)":"{currentRating, plural, =1{# つ星} other{# つ星}}"};